import { render, staticRenderFns } from "./H1Dialog.vue?vue&type=template&id=ffc7032e&scoped=true&"
import script from "./H1Dialog.vue?vue&type=script&lang=js&"
export * from "./H1Dialog.vue?vue&type=script&lang=js&"
import style0 from "./H1Dialog.vue?vue&type=style&index=0&id=ffc7032e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc7032e",
  null
  
)

/* custom blocks */
import block0 from "./H1Dialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports